import { render, staticRenderFns } from "./goToSection.vue?vue&type=template&id=0d16721e&"
import script from "./goToSection.vue?vue&type=script&lang=js&"
export * from "./goToSection.vue?vue&type=script&lang=js&"
import style0 from "./goToSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports